<div class="layout-columns-1-1-1">
  <p>
    @if (patientTreatmentForReview.treatmentDate) {
    {{ patientTreatmentForReview.treatmentDate }}
    } @else {
    {{ 'surgical_qa_panel.unknown_treatment_date' | translate }}
    }
  </p>
  <p>
    @if (patientAge) {
    {{ patientAge }}
    } @else {
    {{ 'surgical_qa_panel.patient_age_is_unknown' | translate }}
    }
  </p>
  <p>
    @if (patientTreatmentForReview.surgicalInterventionTypes?.length) { @for (surgicalInterventionType of
    patientTreatmentForReview.surgicalInterventionTypes; track surgicalInterventionType) {
    <span>
      {{ surgicalInterventionType | translate }}
    </span>
    } } @else {
    {{ 'surgical_qa_panel.unknown_intervention_type' | translate }}
    }
  </p>
</div>
